import WhatsappDefaultBackground from "../../../assets/images/whatsapp-default-wallpaper.png";
import {PictureFilled} from "@ant-design/icons";
import "./campaign-thumb-preview.css";
import {StatusView} from "../../../pages/messages/StatusView";

interface CampaignThumbPreviewProps {
    isActive: boolean;
    withImage?: boolean;
    isPending: boolean;
    isDisabled: boolean;
    status: string;
    whatsappTemplateStatus?: string;
    content?: string;
    isEditorMode?: boolean;
    isPartiallySent?: boolean;
    imageUrl?: string;
}

const CampaignThumbPreview = ({ isActive, withImage = false, isPending, isDisabled, status, whatsappTemplateStatus, content, isEditorMode = true, isPartiallySent = false, imageUrl }: CampaignThumbPreviewProps) => {
    return (
        <div className="campaign-thumb-preview-container" style={{ backgroundImage: `url(${WhatsappDefaultBackground})` }}>
            <div className="statuses">
                <div className="icons">
                    <div className="row">
                        {isEditorMode ? <>
                            {isActive ? <div className="status activated" /> : isPending ? <div className="status pending" /> : <div className="status deactivated" />}
                            {withImage ? <div className={`with-image${imageUrl ? '-url' : ''}`}>{imageUrl ? <img src={imageUrl} /> : <PictureFilled />}</div> : null}
                        </> : <div className="status-container"><StatusView value={isPartiallySent ? 'DELIVERED' : 'READ'} />{isPartiallySent ? 'Partially Sent' : 'Sent'}</div>}
                    </div>
                </div>
                {isEditorMode ? <div className={`campaign-thumb-status ${isDisabled ? 'DISABLED' : whatsappTemplateStatus}`}>
                    {isDisabled ? 'disabled' : status}
                </div> : null}
            </div>
            <div className="campaign-thumb-preview">
                {content}
            </div>
        </div>
    )
}

export default CampaignThumbPreview;